import { render, staticRenderFns } from "./UserPasswordNew.vue?vue&type=template&id=7ac5c1de&"
import script from "./UserPasswordNew.vue?vue&type=script&lang=js&"
export * from "./UserPasswordNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports